module.exports = __webpack_public_path__ + "img/idtypification.fe3409c2.png";